import httpClient from "./httpClient";

const AnnouncementHospitalService = {
  async findByAnnouncement(announcementId) {
    const response = await httpClient.get(`/announcement-hospital/get-by-announcement/${announcementId}`);
    return response.data;
  },

  async assign(announcementId, hospitalFacilityIds) {
    const response = await httpClient.post("/announcement-hospital/assign", {
      announcementId,
      hospitalFacilityIds,
    });
    return response.data;
  },

  async update(id, entity) {
    const response = await httpClient.put(`/announcement-hospital/${id}`, entity);
    return response.data;
  },

  async remove(id) {
    const response = await httpClient.delete(`/announcement-hospital/${id}`);
    return response.data;
  },
};

export default AnnouncementHospitalService;
